module.exports = __webpack_public_path__ + "static/media/IVBDS.47c454f3.pdf";